import { PopoverDisclosure, PopoverStateReturn } from 'reakit/Popover';
import { cx } from '@linaria/core';
import { forwardRef } from 'react';

export interface PopoverActionProps extends React.HTMLAttributes<HTMLElement> {
  popover: PopoverStateReturn;
  disabled?: boolean;
  as?: React.ElementType;
}

export const PopoverAction = forwardRef<HTMLDivElement, PopoverActionProps>(({ popover, children, as = 'div', ...rest }, ref) => (
  <PopoverDisclosure as={as} ref={ref} className={cx(rest.className)} {...rest} {...popover}>
    {children}
  </PopoverDisclosure>
));
